import { createContext } from "react";
import HEvent, { HEventSettings } from "../lib/HEvent";

export class SpikerBoardContextI {
    event = new HEvent();
    categories = [];
    eventSettings = new HEventSettings();
    c_FinishLinePunchesRef = [];
    setSpikerBoardContext() { }
}
export const SpikerBoardContext = createContext(new SpikerBoardContextI());